// material-ui
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";

// project import
import MainCard from "components/MainCard";
import { FormattedMessage } from "react-intl";

import { PurchasedResume } from "types/orders-managment/resume";

// ==============================|| EXPANDING TABLE - PURCHASED RESUME DETAILS ||============================== //

interface ExpandingPurchasedResumeDetailsProps {
  data: PurchasedResume;
}

const ExpandingPurchasedResumeDetails = ({
  data,
}: ExpandingPurchasedResumeDetailsProps) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title={<FormattedMessage id="Purchased Resume Details" />}>
            <List sx={{ py: 0 }}>
              {/* ID */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="ID" />
                      </Typography>
                      <Typography>{data.id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Status" />
                      </Typography>
                      <Typography>
                        {data.status ? (
                          <FormattedMessage id="Active" />
                        ) : (
                          <FormattedMessage id="Inactive" />
                        )}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* User ID & Resume ID */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="User ID" />
                      </Typography>
                      <Typography>{data.user_id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Resume ID" />
                      </Typography>
                      <Typography>{data.resume_id}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Resume Subscription ID */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Resume Subscription ID" />
                      </Typography>
                      <Typography>{data.resume_subscription_id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Created At" />
                      </Typography>
                      <Typography>{data.created_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingPurchasedResumeDetails;
